import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=3d2a1eaa&scoped=true&lang=pug"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a1eaa",
  null
  
)

export default component.exports